<template>
  <handbook-list title="病害手册" kindLabel="病害" :api="api" />
</template>
<script>
import { diseaseApi } from '@/api/plantProtect'
import HandbookList from '../handbook/HandbookList.vue'
export default {
  name: 'DiseaseHandbook',
  components: { HandbookList },
  data() {
    return { api: diseaseApi }
  },
}
</script>
